import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Divider,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Typography
} from '@mui/material';
import { Bert } from 'meteor/themeteorchef:bert';

import EditIcon from '@mui/icons-material/Edit';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RouteIcon from '@mui/icons-material/Route';
import useTimeStore from '../ZustandProvider';

const CreateRouteOnMap = ({ defaultType }) => {
  const [open, setOpen] = React.useState(false);
  const [typeRouteSelect, setTypeRouteSelect] = React.useState(defaultType);
  const pointsRoute = useTimeStore(state => state.pointsRoute);
  const geometryConfig = useTimeStore(state => state.geometryConfig);
  const setDrawRoute = useTimeStore(state => state.setDrawRoute);
  const setGeometryConfig = useTimeStore(state => state.setGeometryConfig);

  const typeRouteOptions = [
    { value: 'foot-walking', name: 'Walking' },
    { value: 'driving-car', name: 'By car' }
  ];

  const createRoute = async () => {
    const intermediate = pointsRoute.slice(2);
    try {
      const response = await fetch('https://sd1.ipsgeoprocesing.ipsilum.com/MG/utilities/routing', {
        method: 'POST',
        body: JSON.stringify({
          start_point: pointsRoute[0],
          final_points: [pointsRoute[1]],
          avoid_points: [],
          intermediate_points: intermediate,
          type_moving: typeRouteSelect
        }),
        headers: { 'Content-Type': 'application/json' },
        mode: 'cors',
        credentials: 'omit',
        referrerPolicy: 'no-referrer'
      });
      const respuesta = await response.json();
      if (respuesta && respuesta.data) {
        setDrawRoute({
          data: respuesta.data,
          centerOnRoute: true
        });
      } else {
        Bert.alert('No possible route found', 'info');
      }
    } catch (error) {
      Bert.alert('Error al obtener la ruta', 'error');
    }
  };

  return (
    <Box>
      <Box display="flex" alignItems="center" width="100%" mb={2}>
        <IconButton onClick={() => setOpen(!open)}>
          {open ? <ExpandMoreIcon /> : <ExpandLessIcon />}
        </IconButton>
        <Typography variant="body1" sx={{ marginRight: 2 }}>
          Get route by selecting points on the map
        </Typography>
        <Divider sx={{ flexGrow: 1, height: 1, backgroundColor: 'grey' }} />
      </Box>

      {open && (
        <>
          <Box display="flex" justifyContent="space-evenly" width="100%" mb={2}>
            <Typography>
              First, select the starting point. Second, select the end point. Then, select the
              intermediate points through which you want to pass. Finally, click the button to draw
              the route.
            </Typography>
          </Box>
          <Box display="flex" justifyContent="space-evenly" width="100%">
            <FormControl variant="outlined" sx={{ minWidth: 160 }}>
              <InputLabel>Saving system</InputLabel>
              <Select
                value={typeRouteSelect}
                label="Saving system"
                onChange={event => setTypeRouteSelect(event.target.value)}
                size="small"
              >
                {typeRouteOptions.map(item => (
                  <MenuItem key={item.value} value={item.value}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              variant="outlined"
              sx={{
                color: geometryConfig === 'RouteOnMap' ? 'white' : '#2A3F90',
                backgroundColor: geometryConfig === 'RouteOnMap' ? '#2A3F90' : 'white',
                '&:hover': {
                  backgroundColor: geometryConfig === 'RouteOnMap' ? '#2A3F90' : 'white'
                },
                borderColor: '#2A3F90'
              }}
              onClick={() => {
                if (geometryConfig === 'RouteOnMap') {
                  setGeometryConfig('LocationComponent');
                } else {
                  setGeometryConfig('RouteOnMap');
                }
              }}
              startIcon={<EditIcon />}
            >
              Draw points
            </Button>
            <Button
              variant="outlined"
              sx={{
                color: '#2A3F90',
                borderColor: '#2A3F90',
                '&:hover': {
                  backgroundColor: '#2A3F90',
                  color: 'white'
                }
              }}
              onClick={() => {
                if (pointsRoute.length >= 2) {
                  setGeometryConfig('LocationComponent');
                  createRoute();
                } else {
                  Bert.alert('At least 2 points are required.', 'info');
                }
              }}
              startIcon={<RouteIcon />}
            >
              Draw Route
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
};

export default CreateRouteOnMap;

CreateRouteOnMap.defaultProps = {
  defaultType: 'foot-walking'
};
CreateRouteOnMap.propTypes = {
  defaultType: PropTypes.string
};
